import { render, staticRenderFns } from "./edit-tags.vue?vue&type=template&id=77c36c3e&scoped=true&"
import script from "./edit-tags.vue?vue&type=script&lang=js&"
export * from "./edit-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c36c3e",
  null
  
)

export default component.exports